<template>
  <div class="card">
      <div class="card-header pb-0">
          <h6>Inventario General</h6>
          <div class="container-fluid d-flex align-items-center justify-content-between input-group">
              <div class="row col-md-12 col-sm-12">
                  <div class="d-flex align-items-center gap-4 px-4 my-2 justify-content-start col-md-4 col-sm-12">
                      <label for="customPageSize">Rango </label>
                      <select @change="customPage($event)" name="customPageSize" class="form-control w-25 text-center">
                          <option v-for="i in customPages" v-bind:key="i">{{ i }}</option>
                      </select>
                  </div>
                  <div class="row gap-4 justify-content-between align-items-center col-md-8 col-sm-12">
                      <button type="button" class="btn btn-outline-primary mb-1 px-2 d-flex align-items-start justify-content-center col-md-2 col-sm-12" 
                      @click="downloadFile" title="Productos Xhantae xlsx">Descargar</button>
                      <div class="mb-0 e-md-3 d-flex align-items-center col-md-4 col-sm-12">
                          <span class="text text-body w-10">
                          <i class="fas fa-search" aria-hidden="true"></i>
                          </span>
                          <input type="text" v-model="searchQuery" @keypress="searchContent" name="search" id="search" class="form-control p-2" placeholder="Buscar.....">
                      </div>
                  </div>
              </div>
            </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
          <div class="table-container">
              <div class="table-row table-header text-xss text-uppercase"
              >
              <div class="table-cell" v-for="header in headers" v-bind:key="header.text">{{ header.text }}</div>
              </div>
              <div v-for="product in products" :key="product.id" class="table-row">
              <div class="table-cell">{{ product.sku }}</div>
              <div class="table-cell">{{ product.original_sku }}</div>
              <div class="table-cell">{{ product.name }}</div>
              <div class="table-cell">{{ product.price }}</div>
              <div class="table-cell">{{ product.stock }}</div>
              <div class="table-cell">{{ product.talla }}</div>
              <div class="table-cell">{{ product.category }}</div>
              </div>
          </div>
          <div v-if="isFailed" class="d-flex align-items-center justify-content-center p-4">
              <span class="text-danger font-weight-bold">{{ errorMessage }}</span>
          </div>
          <div class="d-flex justify-content-center" v-if="!isFailed">
              <nav aria-label="Page navigation example">
              <ul class="pagination">
                  <li class="page-item">
                  <a class="page-link" href="#"
                  v-if="currentPage > 0" @click="prevPage"
                  aria-label="Previous">
                      <i class="fa fa-angle-left"></i>
                      <span class="sr-only">Anterior</span>
                  </a>
                  </li>
                  <li class="page-item" v-for="page in pages" :key="page" :class="{active: page === currentPage}">
                  <a class="page-link" @click="goToPage(page)" 
                  href="#">{{ page }}</a>
                  </li> 
                  <li class="page-item">
                  <a class="page-link" 
                  v-if="currentPage < totalPages - 1" @click="nextPage"
                  href="#" aria-label="Next">
                      <i class="fa fa-angle-right"></i>
                      <span class="sr-only">Siguiente</span>
                  </a>
                  </li>
              </ul>
              </nav>
          </div>
          <div v-if="isLoading" class="table-responsive p-0 align-items-center justify-content-center">
              <div class="d-flex align-items-center justify-content-center"><i class="fa fa-spinner fa-spin"></i>Loading....</div>
          </div>
          

      </div>
  </div>
</template>
<script>
const API_URL = "https://admin.xhantae.com/"
export default {
name: "inventory-table",
data: () => ({
  headers: [
    {
      text: "#SKU",
      sortable: true,
      value: "1"
    },
    { text: "Sku Original", sortable: true, value: "100" },
    { text: "Nombre",sortable: true, value: "Prueba" },
    { text: "Precio",sortable: true, value: "100" },
    { text: "Stock", sortable: true, value: "10" },
    { text: "Categoria", sortable: true, value: "2" },
    { text: "Talla", sorteable: true, value: "0" },
  ],
  customPages: [5, 10, 15, 25, 50],
  products: [],
  elements: [],
  searchQuery: '',
  dates: [],    
  currentPage: 1,
  pageSize: 25,
  totalPages: 10,
  isLoading: true,
  showAll: false, 
  startPage: 1,
  endPage: 5,
  isFailed: true,
  errorMessage: ''
}),
computed: {
  displayItems() {   
    return this.products 
  },
  showMoreButton() {
    return this.pageSize < this.products.length
  },
  pages() {
    const pagesArray = []
    for(let i = this.startPage; i <= this.endPage; i++) {
      pagesArray.push(i)
    } 
    return pagesArray.slice(1, this.pageSize)
  }
},
methods: {
  nextPage() {
    this.currentPage++;
    this.goToPage(this.currentPage)
  },
  prevPage() {
    if(this.currentPage > 0) {
      this.currentPage --;
      this.goToPage(this.currentPage)
    }
  },
  goToPage(page) {
    
    if(page >= this.endPage) {
      this.startPage = page
      this.endPage = page + 5
    }
    else if(page === this.startPage + 1) {
      const validate = this.startPage - 5
      this.startPage = validate > 0 ? validate : 1
      this.endPage = page < 5 ? 5 : page
    }
    this.currentPage = page
    this.loadTable(page, this.pageSize, this.searchQuery)
  },
  showMore(limit) {
    this.loadTable(this.currentPage, limit, this.searchQuery)
  },
  searchContent() {
    this.loadTable(this.currentPage, this.pageSize, this.searchQuery)
  },
  customPage(page) {
    const formatPage = parseInt(page.target.value)
    this.pageSize = formatPage
    this.loadTable(this.currentPage, this.pageSize)
  },
  async loadTable(page, limit, search) {
    let URL = `${API_URL}api/localxpose/products?page=${page}&limit=${limit}`
    if(search !== undefined && search.length >= 3) 
      URL += `&search=${search}`

    await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type' : 'application/json'
      },
      redirect : 'follow'
    })
    .then((res) => res.json())
    .then((response) => {
      if(!response.status)
        console.log("Response error");
      this.products = response.data
      this.currentPage = response.currentPage
      this.pageSize = response.pageSize
      this.totalPages = response.pages
      this.isLoading = false
      this.isFailed = false
    }).catch( () => {
      
      this.errorMessage = "Ocurrió un error al obtener los datos, intente mas tarde nuevamente."
      this.isLoading = false
    })
  },
  downloadFile() {
    fetch(`${API_URL}api/localxpose/download`).then( res => res.blob())
    .then( data => {
      let time = new Date().getTime()
      const a = document.createElement('a')
      a.href = window.URL.createObjectURL(data)
      a.download = `ProductosOaxum_${time}.xlsx`
      a.click()
    })
  }
},
beforeMount() {
  this.loadTable(1,this.pageSize, this.searchQuery)
}
};
</script> 
<style>
.table-container {
display: flex;
flex-direction: column;
padding: 20px;
border-radius: 10px;
}

.table-row {
display: flex;
flex-direction: row;
}

.table-header {
font-weight: bold;
background: linear-gradient(310deg, #f5365c 0%, #f5365c 100%);
color: white;
padding: 5px;
border-radius: 10px;
}

.table-cell {
padding: 8px;
flex: 1;
}
@media (min-width: 769px) {
.table-cell {
  font-size: 12px;
}
}
@media (max-width: 768px) {
.table-container {
  flex-direction: column;
}
.table-row {
  flex-flow: wrap row;
}
.table-cell {
  /* flex: none; */
  width: 100%;
  font-size: 10px;
}
.table-header {
  font-size: xx-small;
}
}
</style>